module.exports = __webpack_public_path__ + "78c1f561f5f65f34261ec595d9c77261.svg";